import { AmenitiesStateInterface } from '.';

function state(): AmenitiesStateInterface {
  return {
    amenities: [],
  };
}

export default state;
